// The `./letters` door's transport seam — see `../../../ehr/data/api/ehrHttp.ts`
// for why this is a function rather than a module-level constant, and why the
// scribe client family (not document-inbox's `loadInboxHttp`) is the right
// transport for an ml-scribe route.
import { getScribeHttpClients } from '@heidi/api/client';

/** The app's `scribeHttpV2` axios instance (`/api/v2/ml-scribe/`). */
export const http = () => getScribeHttpClients().scribeHttpV2;
